import { render } from "./ThreadView.vue?vue&type=template&id=73d8ecb6"
import script from "./ThreadView.vue?vue&type=script&lang=js"
export * from "./ThreadView.vue?vue&type=script&lang=js"

import "./ThreadView.vue?vue&type=style&index=0&id=73d8ecb6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__